
/*
 * GABADINI SLEEP — CAMPAIGN PDP PRESENTATION
 * Stage 5: First-payment pricing display only.
 *
 * Does not change selling plans, product forms,
 * subscription selections, cart or discounts.
 */

(() => {
  'use strict';

  const BLOCK = '[data-gabadini-product-handle]';
  const ACTIVE_CLASS = 'gabadini-campaign-pricing-active';

  let renderPending = false;

  function hideCampaignPrice(block, panel) {
    if (panel) panel.hidden = true;
    block.classList.remove(ACTIVE_CLASS);
  }

  function formatPrice(cents, currency) {
    return new Intl.NumberFormat(
      document.documentElement.lang || 'en-GB',
      {
        style: 'currency',
        currency: currency
      }
    ).format(cents / 100);
  }

  function renderBlock(block) {
    const panel = block.querySelector(
      '[data-gabadini-campaign-pricing]'
    );

    if (!panel) return;

    const campaignId =
      window.GabadiniCampaignIdentity?.getActive?.();

    const campaign =
      window.GabadiniCampaigns?.[campaignId];

    const classifier =
      window.GabadiniCampaignController
        ?.classifyProductHandle;

    const productType =
      typeof classifier === 'function'
        ? classifier(block.dataset.gabadiniProductHandle)
        : null;

    const purchaseType = block.querySelector(
      'input[type="radio"]:checked'
    )?.value;

    const selectedPlan = block.querySelector(
      '[data-plan-id][aria-pressed="true"]'
    );

    const normalPrice = Number(
      selectedPlan?.dataset.planPrice
    );

    const percentage =
      campaign?.discounts?.[productType]?.percentage;

    const form =
      block.closest('product-info')?.querySelector(
        'form.shopify-product-form[action*="/cart/add"]'
      ) ||
      document.querySelector(
        'form.shopify-product-form[action*="/cart/add"]'
      );

    const formPlanId =
      form?.querySelector('[name="selling_plan"]')?.value;

    const currency =
      block.dataset.gabadiniCurrency ||
      window.Shopify?.currency?.active ||
      '';

    // Fail closed if anything is missing or inconsistent.
    if (
      !campaign ||
      campaign.offer?.type !== 'first_subscription_payment' ||
      !productType ||
      purchaseType !== 'subscription' ||
      !selectedPlan ||
      !Number.isFinite(normalPrice) ||
      normalPrice <= 0 ||
      !Number.isFinite(percentage) ||
      percentage <= 0 ||
      percentage > 100 ||
      formPlanId !== selectedPlan.dataset.planId ||
      !/^[A-Z]{3}$/.test(currency)
    ) {
      hideCampaignPrice(block, panel);
      return;
    }

const firstPayment = normalPrice - Math.floor(
  normalPrice * percentage / 100
);


    const frequency = selectedPlan.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const first = panel.querySelector(
      '[data-gabadini-first-payment]'
    );

    const renewal = panel.querySelector(
      '[data-gabadini-renewal]'
    );

    const note = panel.querySelector(
      '[data-gabadini-campaign-note]'
    );

    if (!first || !renewal || !note) {
      hideCampaignPrice(block, panel);
      return;
    }

    try {
      first.textContent =
        'First subscription payment: ' +
        formatPrice(firstPayment, currency);

      renewal.textContent =
        'Then ' +
        formatPrice(normalPrice, currency) +
        ' every ' +
        frequency;

      note.textContent =
        (campaign.audience || 'Campaign') +
        ' offer. Discount applies to your first ' +
        'subscription payment only.';

      panel.hidden = false;
      block.classList.add(ACTIVE_CLASS);

    } catch (error) {
      hideCampaignPrice(block, panel);
      console.warn(
        'GABADINI: Campaign PDP display unavailable.',
        error
      );
    }
  }

  function renderAll() {
    document.querySelectorAll(BLOCK).forEach(renderBlock);
  }

  function scheduleRender() {
    if (renderPending) return;

    renderPending = true;

    requestAnimationFrame(() => {
      renderPending = false;
      renderAll();
    });
  }

  // Observe existing controls; never operate them.
  document.addEventListener('click', event => {
    if (
      event.target instanceof Element &&
      event.target.closest(
        '[data-gabadini-product-handle] [data-plan-id]'
      )
    ) {
      scheduleRender();
    }
  });

  document.addEventListener('change', event => {
    if (
      event.target instanceof Element &&
      (
        event.target.closest(BLOCK) ||
        event.target.matches('[name="selling_plan"]')
      )
    ) {
      scheduleRender();
    }
  });

  // Support Shopify theme-editor section reloads.
  document.addEventListener(
    'shopify:section:load',
    scheduleRender
  );

  // Restore normal subscription pricing after expiry.
  document.addEventListener(
    'gabadini:campaign-expired',
    scheduleRender
  );


  window.addEventListener('pageshow', scheduleRender);

  // Allow existing Purchase Options initialization to settle.
  function initialize() {
    requestAnimationFrame(() => {
      requestAnimationFrame(scheduleRender);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      { once: true }
    );
  } else {
    initialize();
  }
})();
